const upperCase = (value) => /[A-Z]/.test(value)
const lowerCase = (value) => /[a-z]/.test(value)
const number = (value) => /[0-9]/.test(value)
    /* eslint-disable no-useless-escape */
const special = (value) => /[-!$%^&*()_+|~=`{}\[\]:\/;<>?,.@#]/.test(value)



export {
    upperCase,
    lowerCase,
    number,
    special
}